import { Button, styled } from "@mui/material";

export const CustomButton = styled(Button)`
  font-size: 0.75rem;
  font: inherited;
  padding: ${({ theme }) => `0 ${theme.spacing(0.5)} ${theme.spacing(0.25)}`};
`;
